import { Button, LinearProgress, Stack, styled, Typography } from '@mui/material';
import { linearProgressClasses } from '@mui/material/LinearProgress';
import { colors } from 'theme/mui/colors';

type Props = {
  currentStep: number;
  totalStep: number;
  onClickStep?: (step: number) => void;
};

const StepsProgress = (props: Props) => {
  const { currentStep, totalStep, onClickStep } = props;
  const handleClickStep = (step: number) => {
    if (step < currentStep) {
      onClickStep?.(step);
    }
  };

  const progress = (index: number) => {
    if (currentStep === totalStep) return 100; //if the last step is completed, return 100% for all steps
    if (index < currentStep - 1) return 100;
    if (index === currentStep - 1) return 20; //default percentage for the current step
    return 0;
  };

  return (
    <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
      {Array(totalStep)
        .fill(' ')
        .map((step, index) => {
          return (
            <Button
              key={step + index}
              sx={{
                background: 'none !important',
                paddingX: 0,
              }}
              onClick={() => handleClickStep(index + 1)}
              disabled={index >= currentStep - 1 || currentStep === totalStep}
            >
              <StyledLinearProgress variant="determinate" value={progress(index)} />
            </Button>
          );
        })}
      <Typography variant="body2">
        {currentStep}/{totalStep}
      </Typography>
    </Stack>
  );
};

export default StepsProgress;

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: '0.25rem',
  width: '3rem',
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.grey[200],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: colors.emerald.level50,
  },
}));
